import React from "react";
import DecorativeSquares from "../components/ui/DecorativeSquares";
import { useNavigate } from "react-router-dom"; 
import { Calendar } from "lucide-react";
import InputBase from "../components/form/inputs/InputBase";
import { Checkbox, Select } from "../components/form/inputs";
import PrimaryBtn from "../components/button/PrimaryBtn";
import { FaArrowLeft } from "react-icons/fa";

const SetMenu = () => {
  const navigate = useNavigate();

  const mealOptions = [
    { label: "Meal 1", value: "meal_1" },
    { label: "Meal 2", value: "meal_2" },
  ];

  const handleSave = () => {
    navigate("/dashboard");
  };

  return (
    <section className="relative min-h-screen bg-slate-50">
      <DecorativeSquares />

      {/* Header */}
      <div className="flex items-center h-14 mt-5 bg-white px-6 sm:px-8 shadow-sm">
        <button
          onClick={() => navigate("/dashboard")}
          className="p-2 rounded-full hover:bg-gray-100"
        >
          <FaArrowLeft size={20} /> 
        </button>

        <h1 className="mx-auto text-xl sm:text-2xl font-semibold text-gray-900">
          Set today’s menu
        </h1>
      </div>

      {/* Content */}
      <div className="px-4 mt-8">
        <div className="mx-auto max-w-3xl bg-white border border-gray-200 rounded-xl p-6 shadow-sm space-y-6">
          {/* Date Card */}
          <div className="border border-[#FFCCBF] rounded-xl bg-[#FFEFEB] py-3">
            <div className="flex items-center justify-center gap-2 text-[#FF6943] font-semibold text-sm">
              <Calendar size={18} />
              <span>August 01, 2025</span>
            </div>
          </div>

          {/* Form */}
          <div className="space-y-4">
            <Select label="Meal Name" options={mealOptions} />

            <InputBase
              type="textarea"
              rows={3}
              label="Write Menu"
              placeholder="Write menu here..."
            />
          </div>

          {/* Checkbox */}
          <div className="flex items-start gap-3">
            <Checkbox variant="default" />
            <p className="text-sm text-gray-600 leading-relaxed">
              Use this menu for all meals (by checking this box, the system will
              set the same menu for all meals).
            </p>
          </div>
          <div>
            <PrimaryBtn btnName="Set Menu" clickEvent={handleSave} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default SetMenu;
